// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jy-0";
export var fileCarousel = "_jy-2";
export var removeFileButton = "_jy-1";